import { useEffect, useRef, createRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import api from '../../../../../api';

const StickyNav = () => {
  const location = useLocation();

  const underlineRef = useRef(null);
  const navItemsRef = useRef([]);

  const [stickyData, setStickyData] = useState(null);
  const [loading, setLoading] = useState(true);

  // ---------------- Fetch API Data ----------------
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(
          '/api/sitepages/academic/committee-council'
        );

        if (response.data.status) {
          setStickyData(response.data.data.introduction_tabs || []);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // ---------------- Prepare Tabs ----------------
  const validTabs = stickyData
    ? stickyData.filter(tab => tab.heading && tab.url)
    : [];

  // Keep refs in sync with tabs length
  navItemsRef.current = validTabs.map(
    (_, i) => navItemsRef.current[i] ?? createRef()
  );

  // ---------------- Underline Movement ----------------
  const moveUnderline = element => {
    if (!underlineRef.current || !element) return;

    underlineRef.current.style.width = `${element.offsetWidth}px`;
    underlineRef.current.style.left = `${element.offsetLeft}px`;
  };

  // ---------------- Active Tab Logic ----------------
  useEffect(() => {
    if (validTabs.length === 0) return;

    const activeIndex = validTabs.findIndex(tab =>
      tab.url.includes(location.pathname)
    );

    const activeRef =
      activeIndex !== -1
        ? navItemsRef.current[activeIndex]
        : navItemsRef.current[0];

    const activeElement = activeRef?.current;

    if (activeElement) {
      navItemsRef.current.forEach(ref => {
        ref.current?.classList.remove('active');
      });

      activeElement.classList.add('active');
      moveUnderline(activeElement);
    }

    const handleResize = () => {
      const activeEl = document.querySelector(
        '.tab-menu-council ul li.active'
      );
      if (activeEl) moveUnderline(activeEl);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);

  }, [location.pathname, validTabs]);

  // ---------------- Render Guards ----------------
  if (loading) return null;
  if (validTabs.length === 0) return null;

  // ---------------- JSX ----------------
  return (
    <section className="navigation_section sticky-nav">
      <div className="container-fluid px-md-5">
        <div className="row justify-content-center">
          <div className="col-md-10 col-11">
            <div className="tab-menu-council py-3 text-center">
              <ul>
                {validTabs.map((tab, index) => {
                  // Remove domain from API URL for React Router
                  const path = tab.url.replace(/^.*\/\/[^\/]+/, '');

                  return (
                    <li key={tab.id} ref={navItemsRef.current[index]}>
                      <Link to={path || '#'}>{tab.heading}</Link>
                    </li>
                  );
                })}
                <div className="underline" ref={underlineRef} />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StickyNav;
